import axios from '../../../../utills/axiosConfig';

export const fetchLoginLogs = async (user_id) => {
  const res = await axios.get(`/login_logs?user_id=${user_id}`);
  return res.data;
}; 